import PropTypes from "prop-types";
import React from "react";
import { FormattedDate, FormattedMessage } from "react-intl";
import get from "lodash/get";
import IconHorizontalePlane from "app/pages/.shared/IconHorizontalePlane";
import "./MyFlightDetail.scss";
import { getDayCount } from "app/utils/utils";
import first from "lodash/first";
import last from "lodash/last";

const MyFlightDetail = ({ flight }) => {
	const firstOutboundLeg = first(get(flight, "outbound.legs", []));
	const lastOutboundLeg = last(get(flight, "outbound.legs", []));

	const outBoundArrivalDaysCounter = getDayCount(
		get(firstOutboundLeg, "from.takeOffDate"),
		get(lastOutboundLeg, "to.landingDate")
	);

	const firstInboundLeg = first(get(flight, "inbound.legs", []));
	const lastInboundLeg = last(get(flight, "inbound.legs", []));

	const inBoundArrivalDaysCounter = getDayCount(
		get(firstInboundLeg, "from.takeOffDate"),
		get(lastInboundLeg, "to.landingDate")
	);

	return (
		<div className="my-flight-detail">
			<div className="my-flight-detail__item">
				<div className="my-flight-detail__date">
					<IconHorizontalePlane />
					{get(flight, "outbound.legs[0].from.takeOffDate") && (
						<FormattedDate
							timeZone="UTC"
							value={new Date(get(flight, "outbound.legs[0].from.takeOffDate"))}
							weekday="short"
							day="2-digit"
							month="short"
						/>
					)}
				</div>
				<div className="my-flight-detail__itinerary">
					<div className="my-flight-detail__time">
						{get(flight, "outbound.legs[0].from.takeOffTime")} -{" "}
						{get(
							flight,
							`outbound.legs.${get(flight, "outbound.legs.length") -
								1}.to.landingTime`
						)}
						{outBoundArrivalDaysCounter > 0 && (
							<div className="my-flight-detail__days">
								<FormattedMessage
									values={{ day: outBoundArrivalDaysCounter }}
									id="general.arrival.extra.day.counter"
								/>
							</div>
						)}
					</div>
					<div className="my-flight-detail__airport">
						{get(flight, "outbound.legs[0].from.airport")} -{" "}
						{get(flight, "outbound.legs[0].from.iata")} >{" "}
						{get(
							flight,
							`outbound.legs.${get(flight, "outbound.legs.length") - 1}.to.airport`
						)}{" "}
						-{" "}
						{get(
							flight,
							`outbound.legs.${get(flight, "outbound.legs.length") - 1}.to.iata`
						)}
					</div>
				</div>
			</div>
			<div className="my-flight-detail__item">
				<div className="my-flight-detail__date my-flight-detail__date--return">
					<IconHorizontalePlane />
					{get(flight, "inbound.legs[0].from.takeOffDate") && (
						<FormattedDate
							timeZone="UTC"
							value={new Date(get(flight, "inbound.legs[0].from.takeOffDate"))}
							weekday="short"
							day="2-digit"
							month="short"
						/>
					)}
				</div>
				<div className="my-flight-detail__itinerary">
					<div className="my-flight-detail__time">
						{get(flight, "inbound.legs[0].from.takeOffTime")} -{" "}
						{get(
							flight,
							`inbound.legs.${get(flight, "inbound.legs.length") - 1}.to.landingTime`
						)}
						{inBoundArrivalDaysCounter > 0 && (
							<div className="my-flight-detail__days">
								<FormattedMessage
									values={{ day: inBoundArrivalDaysCounter }}
									id="general.arrival.extra.day.counter"
								/>
							</div>
						)}
					</div>
					<div className="my-flight-detail__airport">
						{get(flight, "inbound.legs[0].from.airport")} -{" "}
						{get(flight, "inbound.legs[0].from.iata")} >{" "}
						{get(
							flight,
							`inbound.legs.${get(flight, "inbound.legs.length") - 1}.to.airport`
						)}{" "}
						-{" "}
						{get(
							flight,
							`inbound.legs.${get(flight, "inbound.legs.length") - 1}.to.iata`
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

MyFlightDetail.propTypes = {
	flight: PropTypes.object,
};

MyFlightDetail.defaultProps = {
	flight: {},
};

export default React.memo(MyFlightDetail);
